export const replaceCountryTags = (str, countryName) => {
	if (typeof str === 'string' && str) {
		return str.replace(/<country tag>/g, countryName);
	}
	return '';
};

export const linkify = inputText => {
	if (typeof inputText !== 'string' || !inputText) {
		return '';
	}

	let replacedText;

	// Links with protocol - http://, https://, or ftp://
	const withProtocol = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;()]*[-A-Z0-9+&@#\/%=~_|()])/gim;
	replacedText = inputText.replace(withProtocol, '<a data-lightbox="leavesite" href="$1" target="_blank">$1</a>');

	// Starting with "www." (without // before it, or it'd re-link the ones done above).
	const withWWW = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
	replacedText = replacedText.replace(withWWW, '$1<a data-lightbox="leavesite" href="http://$2" target="_blank">$2</a>');

	// Mailto Links
	const mailTo = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
	replacedText = replacedText.replace(mailTo, '<a href="mailto:$1">$1</a>');

	return replacedText;
};
